/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Type_AuditInputs */

const cs_gdpr_type_audit = /** @type {(inputs: Gdpr_Type_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit`)
};

const en_gdpr_type_audit = /** @type {(inputs: Gdpr_Type_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit`)
};

/**
* | output |
* | --- |
* | "Audit" |
*
* @param {Gdpr_Type_AuditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_type_audit = /** @type {((inputs?: Gdpr_Type_AuditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Type_AuditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_type_audit(inputs)
	return cs_gdpr_type_audit(inputs)
});